/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakStatus } from './StreakStatus';
import {
    StreakStatusFromJSON,
    StreakStatusFromJSONTyped,
    StreakStatusToJSON,
    StreakStatusToJSONTyped,
} from './StreakStatus';

/**
 * 
 * @export
 * @interface UserStreakResponse
 */
export interface UserStreakResponse {
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof UserStreakResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserStreakResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserStreakResponse
     */
    streakConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    currentStreak: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    longestStreak: number;
    /**
     * 
     * @type {StreakStatus}
     * @memberof UserStreakResponse
     */
    status: StreakStatus;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    currentWindowStart?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    currentWindowEnd?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    currentWindowProgress?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserStreakResponse
     */
    currentWindowMet?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    lastCompletedWindow?: number;
    /**
     * Epoch ms — the deadline by which the next window must be met for the streak to survive. Written on every completed window from cadence + grace + shields held; extended when a shield is purchased. Streak liveness is DERIVED from this vs now, so no scheduled sweep is needed to break a streak.
     * @type {number}
     * @memberof UserStreakResponse
     */
    aliveUntil?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    streakStartedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    lastBrokenAt?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    totalCompletedWindows?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    freezesRemaining?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    graceWindowsUsed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserStreakResponse
     */
    isPaused?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    pausedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    activeMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStreakResponse
     */
    multiplierExpiresAt?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserStreakResponse
     */
    claimedMilestones?: Array<number>;
    /**
     * Per-criteria progress within the current window (keyed by criteria index)
     * @type {{ [key: string]: number; }}
     * @memberof UserStreakResponse
     */
    criteriaProgress?: { [key: string]: number; };
    /**
     * Distinct local day keys (YYYY-MM-DD) credited per criterion within the current window, keyed by criteria index. Only populated for DISTINCT_DAYS criteria.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UserStreakResponse
     */
    criteriaDistinctDays?: { [key: string]: Array<string>; };
    /**
     * User IDs of co-op streak participants
     * @type {Array<string>}
     * @memberof UserStreakResponse
     */
    sharedWith?: Array<string>;
    /**
     * UUID linking all participants in a shared streak group
     * @type {string}
     * @memberof UserStreakResponse
     */
    sharedGroupId?: string;
    /**
     * Most-recently-generated AI share copy for this streak's latest milestone. Persisted by StreakEvaluator at milestone-emit time so modal + share-card + OG meta all read the same text.
     * @type {string}
     * @memberof UserStreakResponse
     */
    lastShareCopy?: string;
    /**
     * Epoch ms — when lastShareCopy was generated
     * @type {number}
     * @memberof UserStreakResponse
     */
    lastShareCopyGeneratedAt?: number;
    /**
     * Milestone count the lastShareCopy was generated for
     * @type {number}
     * @memberof UserStreakResponse
     */
    lastShareCopyMilestone?: number;
}



/**
 * Check if a given object implements the UserStreakResponse interface.
 */
export function instanceOfUserStreakResponse(value: object): value is UserStreakResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('streakConfigId' in value) || value['streakConfigId'] === undefined) return false;
    if (!('currentStreak' in value) || value['currentStreak'] === undefined) return false;
    if (!('longestStreak' in value) || value['longestStreak'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UserStreakResponseFromJSON(json: any): UserStreakResponse {
    return UserStreakResponseFromJSONTyped(json, false);
}

export function UserStreakResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserStreakResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'id': json['id'],
        'userId': json['userId'],
        'streakConfigId': json['streakConfigId'],
        'currentStreak': json['currentStreak'],
        'longestStreak': json['longestStreak'],
        'status': StreakStatusFromJSON(json['status']),
        'currentWindowStart': json['currentWindowStart'] == null ? undefined : json['currentWindowStart'],
        'currentWindowEnd': json['currentWindowEnd'] == null ? undefined : json['currentWindowEnd'],
        'currentWindowProgress': json['currentWindowProgress'] == null ? undefined : json['currentWindowProgress'],
        'currentWindowMet': json['currentWindowMet'] == null ? undefined : json['currentWindowMet'],
        'lastCompletedWindow': json['lastCompletedWindow'] == null ? undefined : json['lastCompletedWindow'],
        'aliveUntil': json['aliveUntil'] == null ? undefined : json['aliveUntil'],
        'streakStartedAt': json['streakStartedAt'] == null ? undefined : json['streakStartedAt'],
        'lastBrokenAt': json['lastBrokenAt'] == null ? undefined : json['lastBrokenAt'],
        'totalCompletedWindows': json['totalCompletedWindows'] == null ? undefined : json['totalCompletedWindows'],
        'freezesRemaining': json['freezesRemaining'] == null ? undefined : json['freezesRemaining'],
        'graceWindowsUsed': json['graceWindowsUsed'] == null ? undefined : json['graceWindowsUsed'],
        'isPaused': json['isPaused'] == null ? undefined : json['isPaused'],
        'pausedAt': json['pausedAt'] == null ? undefined : json['pausedAt'],
        'activeMultiplier': json['activeMultiplier'] == null ? undefined : json['activeMultiplier'],
        'multiplierExpiresAt': json['multiplierExpiresAt'] == null ? undefined : json['multiplierExpiresAt'],
        'claimedMilestones': json['claimedMilestones'] == null ? undefined : json['claimedMilestones'],
        'criteriaProgress': json['criteriaProgress'] == null ? undefined : json['criteriaProgress'],
        'criteriaDistinctDays': json['criteriaDistinctDays'] == null ? undefined : json['criteriaDistinctDays'],
        'sharedWith': json['sharedWith'] == null ? undefined : json['sharedWith'],
        'sharedGroupId': json['sharedGroupId'] == null ? undefined : json['sharedGroupId'],
        'lastShareCopy': json['lastShareCopy'] == null ? undefined : json['lastShareCopy'],
        'lastShareCopyGeneratedAt': json['lastShareCopyGeneratedAt'] == null ? undefined : json['lastShareCopyGeneratedAt'],
        'lastShareCopyMilestone': json['lastShareCopyMilestone'] == null ? undefined : json['lastShareCopyMilestone'],
    };
}

export function UserStreakResponseToJSON(json: any): UserStreakResponse {
    return UserStreakResponseToJSONTyped(json, false);
}

export function UserStreakResponseToJSONTyped(value?: UserStreakResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'id': value['id'],
        'userId': value['userId'],
        'streakConfigId': value['streakConfigId'],
        'currentStreak': value['currentStreak'],
        'longestStreak': value['longestStreak'],
        'status': StreakStatusToJSON(value['status']),
        'currentWindowStart': value['currentWindowStart'],
        'currentWindowEnd': value['currentWindowEnd'],
        'currentWindowProgress': value['currentWindowProgress'],
        'currentWindowMet': value['currentWindowMet'],
        'lastCompletedWindow': value['lastCompletedWindow'],
        'aliveUntil': value['aliveUntil'],
        'streakStartedAt': value['streakStartedAt'],
        'lastBrokenAt': value['lastBrokenAt'],
        'totalCompletedWindows': value['totalCompletedWindows'],
        'freezesRemaining': value['freezesRemaining'],
        'graceWindowsUsed': value['graceWindowsUsed'],
        'isPaused': value['isPaused'],
        'pausedAt': value['pausedAt'],
        'activeMultiplier': value['activeMultiplier'],
        'multiplierExpiresAt': value['multiplierExpiresAt'],
        'claimedMilestones': value['claimedMilestones'],
        'criteriaProgress': value['criteriaProgress'],
        'criteriaDistinctDays': value['criteriaDistinctDays'],
        'sharedWith': value['sharedWith'],
        'sharedGroupId': value['sharedGroupId'],
        'lastShareCopy': value['lastShareCopy'],
        'lastShareCopyGeneratedAt': value['lastShareCopyGeneratedAt'],
        'lastShareCopyMilestone': value['lastShareCopyMilestone'],
    };
}

